if(!customElements.get('swiper-multicolumn')) {
  customElements.define(
    'swiper-multicolumn',
    class SwiperMulticolumn extends HTMLElement {
      constructor() {
        super();
        this.swiperElement = this.querySelector('[id^="Swiper-"]');
        this.swiperElementPrev = this.querySelector('[id^="SwiperPrev-"]');
        this.swiperElementNext = this.querySelector('[id^="SwiperNext-"]');
        this.swiperElementPagination = this.querySelector('[id^="SwiperPagination-"]');

        if(!this.swiperElement) return;
        this.initSwiper();
      }

      initSwiper() {
        this.swiper = new Swiper(this.swiperElement, {
          loop: true,
          slidesPerView: 1,
          spaceBetween: 20,
          pagination: {
            clickable: true,
            el: this.swiperElementPagination,
          },
          navigation: {
            prevEl: this.swiperElementPrev,
            nextEl: this.swiperElementNext
          },
          breakpoints: {
            769: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            1025: {
              slidesPerView: 3,
              spaceBetween: 20,
            }
          }
        })
      }
    }
  )
}